import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { BreakpointHelpers } from '../models/BreakpointHelpers';

@Injectable({
  providedIn: 'root',
})
export class BreakpointService implements OnDestroy {
  private destroyed: Subject<void> = new Subject<void>();
  private screenSizeSubject: BehaviorSubject<string> =
    new BehaviorSubject<string>('');
  public screenSize$: Observable<string> =
    this.screenSizeSubject.asObservable();
  private landscapeSubject: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  public isLandscape$: Observable<boolean> =
    this.landscapeSubject.asObservable();
  constructor(private breakpointObserver: BreakpointObserver) {
    this.breakpointObserver
      .observe(BreakpointHelpers.breakpointList)
      .pipe(takeUntil(this.destroyed))
      .subscribe((result) => {
        for (const query of Object.keys(result.breakpoints)) {
          if (result.breakpoints[query]) {
            this.screenSizeSubject.next(
              BreakpointHelpers.displayNameMap.get(query) ?? '',
            );
          }
        }
      });
    this.breakpointObserver
      .observe(BreakpointHelpers.landscapeList)
      .pipe(takeUntil(this.destroyed))
      .subscribe((result: any) => {
        if (result.matches) {
          this.landscapeSubject.next(true);
        } else {
          this.landscapeSubject.next(false);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }
}
